import { createStyles, makeStyles } from '@material-ui/core';

import { variables } from '@styles';

export const useStyles = makeStyles((theme) =>
  createStyles({
    subjectLinePreheaderWrapper: {
      left: '46.3rem',
      position: 'absolute',
      width: 'calc(100% - 46.3rem - 46.3rem)',
      zIndex: 20,

      ['@media (min-width: 1024px) and (max-width: 1650px)']: {
        // left: '26.6rem',
        left: 'calc(50% - 1rem)',
        // width: 'calc(100% - 26.6rem - 28.6rem)',
        transform: 'translateX(-50%)',
        width: '60rem',
      },
    },

    slpExpanded: {
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
      height: 'calc(100% + 3.3rem)',
      left: '-1.7rem',
      top: '-1.6rem',
      transform: 'translateX(0)',
      width: 'calc(100% + 3.4rem)',

      '&& $outerContainer': {
        left: '50%',
        position: 'absolute',
        top: '1.6rem',
        transform: 'translateX(-50%)',

        width: 'calc(100% - 46.3rem - 46.3rem - 3.4rem)',
        // zIndex: 20,

        ['@media (min-width: 1024px) and (max-width: 1650px)']: {
          // left: '26.6rem',
          left: 'calc(50% - 1rem)',
          // transform: 'translateX(calc(-50%))',
          // width: 'calc(100% - 26.6rem - 28.6rem - 3.4rem)',
          width: '60rem',
        },
      },
    },
    outerContainer: {
      position: 'absolute',
      width: '100%',
    },

    subjectLinePreheaderContent: {
      backgroundColor: variables.colorV2.panel.background.default,
      borderRadius: '2rem',
      clipPath: 'border-box',
      minWidth: '60rem',
      left: 'calc(50% - 0.3rem)', //'50%',
      maxWidth: '60rem',
      padding: '2rem 1.6rem',
      position: 'relative',
      top: '0',
      transform: 'translateX(-50%)', // translateX(-50%)',
      width: '90%',

      ['@media (min-width: 1024px) and (max-width: 1650px)']: {
        // left: 'calc(50% - 5.1rem))',
        left: 'calc(50% + 1rem)',
      },
    },
    inputRow: {
      // alignItems: 'left',
      background: variables.color.primary.white,
      display: 'flex',
      justifyContent: 'left',
      margin: '0 0 0.8rem 0',
      padding: '0 0 0 0',
    },
    form: {
      display: 'flex',
      gap: theme.spacing(2),
    },

    buttonContainer: {
      display: 'flex',
      gap: '.5rem',
      justifyContent: 'flex-end',
      minWidth: '100%',
      width: '100%',
    },
    button: {
      margin: 'auto 0',
      // width: '4.8rem',
    },
    saveButton: {
      // '&:disabled': {
      //   backgroundColor: variables.colorV2.button.disabled.background.default + ' !important',
      //   border: `0.1rem solid ${variables.colorV2.button.disabled.border.default}`,
      //   color: variables.colorV2.button.disabled.text.default,
      // },
    },
    cancelButton: {
      borderRadius: '3.2rem',
      // backgroundColor: variables.colorV2.button.alternate.background.default,
      // border: `1px solid ${variables.colorV2.button.alternate.border.default}`,
      // color: variables.colorV2.button.alternate.text.default,
      // '&:hover': {
      //   backgroundColor: variables.colorV2.button.alternate.background.hover,
      //   border: `1px solid ${variables.colorV2.button.alternate.border.hover}`,
      //   color: variables.colorV2.button.alternate.text.hover,
      // },
      // '&:hover svg path': {
      //   fill: variables.colorV2.button.alternate.icon.hover,
      // },
    },
    personalizationPanel: {
      left: 'calc((100vw - ( 7.6rem + 1.6rem + 44.8rem + 1.6rem + 1.6rem + 44.8rem + 1.6rem )) * .95 + (1.6rem + 44.8rem + 1.6rem + 1.6rem))',
      position: 'absolute',
      // right: '1.6rem',
      top: '1.7rem',
      zIndex: 1000,

      ['@media (min-width: 1024px) and (max-width: 1650px)']: {
        left: 'calc((100vw - ( 7.6rem + 1.6rem + 26.6rem + 1.6rem + 1.6rem + 27rem + 1.6rem )) * .95 + (1.6rem + 26.6rem + 1.6rem + 1.6rem))',
      },
    },
  }),
);
